module.exports = __webpack_public_path__ + "img/AE5003-01.382038c3.jpg";